import React from 'react';
import { oneOf } from 'prop-types';

import BacnetInventoryTable from './BacnetInventoryTable';
import NiagaraInventoryTable from './NiagaraInventoryTable';
import ExistingProfileTable from './ExistingProfileTable';

const TableTypes = {
    bacnetethernet:  BacnetInventoryTable,
    bacnetip:        BacnetInventoryTable,
    niagara:         NiagaraInventoryTable,
    existingProfile: ExistingProfileTable
};

const InventoryTable = ({ onDeviceChange, type, ...props }) => {
    const Table = TableTypes[type];
    if (!Table) {
        return null;
    }
    return <Table {...props} />;
};

InventoryTable.propTypes = {
    type: oneOf(Object.keys(TableTypes)).isRequired
};

export default InventoryTable;
